export default "__VITE_PUBLIC_ASSET__de7dca1f__"